import {
  ADD_FLOOR_FAILURE,
  ADD_FLOOR_REQUEST,
  ADD_FLOOR_SUCCESS,
  DELETE_FLOOR_FAILURE,
  DELETE_FLOOR_REQUEST,
  DELETE_FLOOR_SUCCESS,
  FETCH_FLOOR_FAILURE,
  FETCH_FLOOR_REQUEST,
  FETCH_FLOOR_SUCCESS,
  FETCH_LIST_All_FLOOR_FAILURE,
  FETCH_LIST_All_FLOOR_REQUEST,
  FETCH_LIST_All_FLOOR_SUCCESS,
  FETCH_LIST_AllS_FLOOR_FAILURE,
  FETCH_LIST_AllS_FLOOR_REQUEST,
  FETCH_LIST_AllS_FLOOR_SUCCESS,
  FETCH_LIST_FLOOR_FAILURE,
  FETCH_LIST_FLOOR_REQUEST,
  FETCH_LIST_FLOOR_SUCCESS,
  RESET_CURRENT_FLOOR,
  UPDATE_FLOOR_FAILURE,
  UPDATE_FLOOR_REQUEST,
  UPDATE_FLOOR_SUCCESS,
} from "./floorType";

export const fetchAllFloors = () => {
  return {
    type: FETCH_LIST_All_FLOOR_REQUEST,
  };
};

export const fetchAllFloorsSuccess = (floors) => ({
  type: FETCH_LIST_All_FLOOR_SUCCESS,
  payload: { floors },
});

export const fetchAllFloorsFailure = (error) => ({
  type: FETCH_LIST_All_FLOOR_FAILURE,
  payload: { error },
});

export const fetchallFloors = (pageNo) => {
  return {
    type: FETCH_LIST_AllS_FLOOR_REQUEST,
    payload: pageNo,
  };
};

export const fetchallFloorsSuccess = (floors) => ({
  type: FETCH_LIST_AllS_FLOOR_SUCCESS,
  payload: { floors },
});

export const fetchallFloorsFailure = (error) => ({
  type: FETCH_LIST_AllS_FLOOR_FAILURE,
  payload: { error },
});
export const fetchFloors = (blockId, pageNo) => {
  return {
    type: FETCH_LIST_FLOOR_REQUEST,
    payload: { blockId, pageNo },
  };
};

export const fetchFloorsSuccess = (floors) => ({
  type: FETCH_LIST_FLOOR_SUCCESS,
  payload: { floors },
});

export const fetchFloorsFailure = (error) => ({
  type: FETCH_LIST_FLOOR_FAILURE,
  payload: { error },
});

// View single floor
export const fetchFloor = (floorId) => ({
  type: FETCH_FLOOR_REQUEST,
  payload: { floorId },
});

export const fetchFloorSuccess = (floor) => ({
  type: FETCH_FLOOR_SUCCESS,
  payload: { floor },
});

export const fetchFloorFailure = (error) => ({
  type: FETCH_FLOOR_FAILURE,
  payload: { error },
});

// Add floor
export const addFloor = (floorData) => ({
  type: ADD_FLOOR_REQUEST,
  payload: { floorData },
});

export const addFloorSuccess = (floor) => ({
  type: ADD_FLOOR_SUCCESS,
  payload: { floor },
});

export const addFloorFailure = (error) => ({
  type: ADD_FLOOR_FAILURE,
  payload: { error },
});

// Edit floor
export const updateFloor = (floorId, floorData) => ({
  type: UPDATE_FLOOR_REQUEST,
  payload: { floorId, floorData },
});

export const updateFloorSuccess = (floor) => ({
  type: UPDATE_FLOOR_SUCCESS,
  payload: { floor },
});

export const updateFloorFailure = (error) => ({
  type: UPDATE_FLOOR_FAILURE,
  payload: { error },
});

// Delete floor
export const deleteFloor = (floorId) => ({
  type: DELETE_FLOOR_REQUEST,
  payload: { floorId },
});

export const deleteFloorSuccess = (floorId) => ({
  type: DELETE_FLOOR_SUCCESS,
  payload: { floorId },
});

export const deleteFloorFailure = (error) => ({
  type: DELETE_FLOOR_FAILURE,
  payload: { error },
});

// Reset current floor
export const resetCurrentFloor = () => ({
  type: RESET_CURRENT_FLOOR,
});
